import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AsyncSubject, BehaviorSubject, forkJoin, of, Subject } from 'rxjs';
import { catchError, debounceTime, delay, map, mergeMap, pairwise, startWith, takeUntil } from 'rxjs/operators';
import { PriceArticoloService } from 'src/app/shared/services/custom/price-articolo.service';
import { ShopService } from 'src/app/shared/api/shop.service';
import { AccountService } from 'src/app/shared/services/custom/account.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Destinazione } from 'src/app/shared/interfaces/custom/destinazione';
import { ShippingCostService } from 'src/app/shared/services/custom/shipping-cost.service';
import { StoreService } from 'src/app/shared/services/store.service';
import { NavigationStart, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { formatDate } from 'src/app/shared/helpers/formatDate';
import { ArticoloFull } from 'src/app/shared/interfaces/custom/articolo';
import { getOrariDisponibiliPerFinestra } from 'src/app/shared/helpers/orari_ritiro';
import { ImpostazioniRitiro } from 'src/app/shared/interfaces/custom/orario';
import { Livello } from 'src/app/shared/interfaces/custom/componibili';
import { getTipoSpedizioneStr } from 'src/app/shared/interfaces/custom/spedizione';
import { ProductCustomizationComponent } from 'src/app/shared/components/product-customization/product-customization.component';
import { Attributo } from 'src/app/shared/interfaces/custom/attributi';
import { GiacenzaControlService } from 'src/app/shared/services/giacenza-control.service';
import { CartService } from 'src/app/shared/services/cart.service';
import { RootService } from 'src/app/shared/services/root.service';
import { CartItem } from 'src/app/shared/interfaces/cart-item';

export interface Item {
    cartItem: CartItem;
    quantity: number;
    quantityControl: FormControl;
}

enum REASON_NOT_AVAILABLE {
    PRINCIPIO_ARTICOLO = 1,
    LIMIT = 2,
    PRINCIPIO_GEOGRAFICO = 3,
    PRINCIPIO_CLIENTE = 4,
    PRINCIPIO_PESO = 5
}

@Component({
  selector: 'app-restaurantcart',
  templateUrl: './restaurantcart.component.html',
  styleUrls: ['./restaurantcart.component.scss']
})
export class RestaurantcartComponent implements OnInit, OnDestroy {
    private destroy$: Subject<void> = new Subject();

    private destinazioneScelta$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    removedItems: CartItem[] = [];
    items: Item[] = [];
    updating = false;
    destinazioni;
    destinazioneScelta;

    modalitaDiSpedizione;
    controlModalitaDiSpedizione = new FormControl();
    spedizioniNonDisponibili;

    fasceDisponibili;
    orariDisponibili;

    fasciaGiorno = new FormControl();
    fasciaOra = new FormControl();

    ritiroGiorno = new FormControl();
    ritiroRange = new FormControl();

    note = new FormControl();

    min(articolo: ArticoloFull) {
        if (this.store.price == 'b2c')
            return 1;
        else if (articolo.conf_active)
            return articolo.conf_active.pezzi_confezione;
        else
            return articolo.minimo_acquisto;
    }

    step(articolo: ArticoloFull) {
        if (this.store.price == 'b2c')
            return 1;
        else if (articolo.conf_active)
            return articolo.conf_active.pezzi_confezione;
        else
            return articolo.livello_riordino;
    }

    formatDate(date) {
        return formatDate(date)
    }

    getFascieOrariePerGiornoSelezionato() {
        let fasceOrarie = this.fasceDisponibili.find(obj => obj.giorno == this.fasciaGiorno.value);
        return fasceOrarie ? fasceOrarie.fasce_disponibili : undefined;
    }

    formatTime(time) {
        return String(Math.floor(time / 60)).padStart(2, '0') + ':' + String(time % 60).padStart(2, '0');
    }

    getOrariPerGiornoSelezionato() {
        let orari = this.orariDisponibili.find(obj => obj.giorno == this.ritiroGiorno.value);
        return orari ? orari.orari_range : undefined;
    }

    @ViewChild('modal', { read: TemplateRef }) template: TemplateRef<any>;
    modalRef: BsModalRef;

    openAddressModal() {
        this.modalRef = this.modalService.show(this.template, { class: 'modal-dialog-centered modal-xl' });
    }

    selectDestinazione(destinazione: Destinazione) {
        this.destinazioneScelta = destinazione;
        this.destinazioneScelta$.next(this.destinazioneScelta);
        this.modalRef.hide();
    }

    b2b;

    constructor(
        public root: RootService,
        public cart: CartService,
        public price: PriceArticoloService,
        public account: AccountService,
        private shop: ShopService,
        private modalService: BsModalService,
        public shippingCost: ShippingCostService,
        private store: StoreService,
        private router: Router,
        private giacenzaControl : GiacenzaControlService
    ) {
        this.b2b = this.store.price == 'b2b';
    }

    cartUpdated$ = new BehaviorSubject<any>(null);

    impostazioni_ritiro: ImpostazioniRitiro;

    impostazioniRitiroAttivo() {
        if (!this.impostazioni_ritiro)
            return false;

        if (!this.destinazioneScelta)
            return false;

        if (!this.modalitaDiSpedizione)
            return false;

        let spedizioneScelta = this.modalitaDiSpedizione.find(obj => obj.codice == this.controlModalitaDiSpedizione.value);
        if (!spedizioneScelta)
            return false;

        if (spedizioneScelta.tipo_spedizione == 1) {
            return true;
        }
        return false;
    }

    orarioRitiroAttivo() {
        if (this.impostazioni_ritiro.delay < 0 || this.impostazioni_ritiro.finestra < 0
            || this.impostazioni_ritiro.split_fasce <= 0)
            return false;

        return true;
    }

    impostazioni_consegna;

    fasciaAttiva() {
        if (!this.destinazioneScelta)
            return false;

        if (!this.modalitaDiSpedizione)
            return false;

        let spedizioneScelta = this.modalitaDiSpedizione.find(obj => obj.codice == this.controlModalitaDiSpedizione.value);
        if (!spedizioneScelta)
            return false;

        // fascia attiva per domicilio e corriere in b2b
        if (this.store.price == 'b2b' && spedizioneScelta.tipo_spedizione != 1)
            return true;

        // fascia attiva solo se domicilio in B2C
        if (this.store.price == 'b2c' && spedizioneScelta.tipo_spedizione == 2) {
            return true;
        }
        return false;
    }

    getModalitaDiSpedizione(modalita) {
        return getTipoSpedizioneStr(modalita);
    }

    errDoc;

    ngOnInit(): void {
        let spedizioniAll$ = new AsyncSubject();

        if (this.account.getUser()) {

            this.shop.getAllSpedizioni().subscribe(r => {
                spedizioniAll$.next(r);
                spedizioniAll$.complete();
            });


            this.shop.getShopInfo().subscribe(shopInfo => {
                this.impostazioni_consegna = shopInfo['impostazioni_consegna'];
            });

            this.controlModalitaDiSpedizione.valueChanges.subscribe(codiceSpedizione => {
                let metodoDiSpedizione = this.modalitaDiSpedizione.find(obj => obj.codice == codiceSpedizione);
                let costo = this.shippingCost.getPriceOfShipping(metodoDiSpedizione, this.cart.subtotal);
                this.cart.setShippingMethod(metodoDiSpedizione ? metodoDiSpedizione : null, costo);

                spedizioniAll$.subscribe((all_spedizioni:any[]) => {
                    this.checkLimitsForSelectedShipping(codiceSpedizione, all_spedizioni);
                    let limitiInfo = all_spedizioni.find(s => s.codice == codiceSpedizione)?.principi_articolo;
                    this.cart.setLimitsForShipping(limitiInfo);
                });
            });

            this.account.getDestinations().subscribe(r => {
                this.destinazioni = r;
                this.destinazioneScelta = this.account.getDefaultDestination(r);
                this.destinazioneScelta$.next(this.destinazioneScelta);
            });

            this.destinazioneScelta$.subscribe(newDestinazione => {
                this.cart.setDestinazione(newDestinazione);

                if (!newDestinazione)
                    return;

                this.modalitaDiSpedizione = null;
                this.errDoc = null;
                spedizioniAll$.pipe(catchError(err => of(null))).subscribe(spedizioniAll => {
                    this.shop.getSpedizioniDisponibili(
                        this.cart.creaDocumentoPerSpedizioniDisponibili(), this.cart.subtotal)
                    .subscribe(
                        r => {
                            this.modalitaDiSpedizione = r;
                            if (!this.modalitaDiSpedizione.find(obj => obj.codice == this.controlModalitaDiSpedizione.value)) {
                                this.controlModalitaDiSpedizione.reset();
                            }
                            this.checkLimitsForSelectedShipping(this.controlModalitaDiSpedizione.value, spedizioniAll);
                            this.updateSpedizioniNonDisponibili(spedizioniAll);
                        },
                        err => {
                            this.modalitaDiSpedizione = null;
                            this.errDoc = err.error.help;
                        }
                    )
                });

                this.fasciaGiorno.reset();
                this.fasciaOra.reset();

                this.ritiroGiorno.reset();
                this.ritiroRange.reset();

                this.shop.getFasce(newDestinazione.codiceDestinazione).subscribe(r => {
                    for (let perGiorno of r) {
                        perGiorno['giorno'] = perGiorno['giorno'].slice(0, 10);
                    }
                    this.fasceDisponibili = r;
                });

                forkJoin([this.store.getImpostazioniDiRitiro(), this.store.getOrariDelNegozio()]).subscribe(r => {
                    this.impostazioni_ritiro = r[0];
                    if (this.orarioRitiroAttivo())
                        this.orariDisponibili = getOrariDisponibiliPerFinestra(r[0], r[1]);
                });
            });

            this.fasciaGiorno.valueChanges.subscribe(r => {
                this.cart.setDeliveryDate(r);
            });

            this.ritiroGiorno.valueChanges.subscribe(r => {
                this.ritiroRange.reset();
            })

            this.fasciaOra.valueChanges.subscribe(r => {
                if (!r)
                    this.cart.setDeliveryTime(null);
                else {
                    let fascia = this.fasceDisponibili.find(obj => obj['giorno'] == this.fasciaGiorno.value);
                    if (!fascia)
                        this.cart.setDeliveryTime(null);
                    else {
                        let f = fascia['fasce_disponibili'].find(obj => obj.id == r);
                        if (!f)
                            this.cart.setDeliveryTime(null);
                        else
                            this.cart.setDeliveryTime(f);
                    }
                }
            });

            this.note.valueChanges.subscribe(r => {
                this.cart.setNote(r);
            });
        }

        // TODO Review this part
        this.cart.items$.pipe(
            takeUntil(this.destroy$),
            map(cartItems => cartItems.map(cartItem => {
                return {
                    cartItem,
                    quantity: cartItem.quantity,
                    quantityControl: new FormControl(cartItem.quantity, Validators.required)
                };
            }))
        ).subscribe(items => {
            this.items = items;
            for (let item of items) {
                item.quantityControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(r => {
                    this.cartUpdated$.next(null);
                });
            }

            this.cartUpdated$.pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe(r => {
                if (this.needUpdate()) {
                    this.update();
                }
            });

        });

        this.cart.subtotal$.pipe(startWith(null), pairwise(), takeUntil(this.destroy$)).subscribe(
            r => {

                if (r[0] == r[1])
                    return;

                let codiceDestinazione = this.destinazioneScelta?.codiceDestinazione;
                if (codiceDestinazione) {
                    this.modalitaDiSpedizione = null;
                    this.spedizioniNonDisponibili = null;
                    spedizioniAll$.pipe(catchError(err => of(null))).subscribe(spedizioniAll => {
                        this.shop.getSpedizioniDisponibili(this.cart.creaDocumentoPerSpedizioniDisponibili(), this.cart.subtotal).subscribe(r => {
                            this.modalitaDiSpedizione = r;
                            if (!this.modalitaDiSpedizione.find(obj => obj.codice == this.controlModalitaDiSpedizione.value)) {
                                this.controlModalitaDiSpedizione.reset();
                            }
                            this.checkLimitsForSelectedShipping(this.controlModalitaDiSpedizione.value, spedizioniAll);
                            this.updateSpedizioniNonDisponibili(spedizioniAll);
                        });
                    });
                }
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    remove(item: CartItem): void {
        if (this.removedItems.includes(item)) {
            return;
        }

        this.removedItems.push(item);
        this.cart.remove(item).subscribe({ complete: () => this.removedItems = this.removedItems.filter(eachItem => eachItem !== item) });
    }

    update(): void {
        this.updating = true;
        this.cart.update(
            this.items
                .filter(item => item.quantityControl.value !== item.quantity)
                .map(item => ({
                    item: item.cartItem,
                    quantity: item.quantityControl.value
                }))
        ).subscribe({ complete: () => this.updating = false });
    }

    needUpdate(): boolean {
        let needUpdate = false;

        for (const item of this.items) {
            if (!item.quantityControl.valid) {
                return false;
            }

            if (item.quantityControl.value !== item.quantity) {
                needUpdate = true;
            }
        }

        return needUpdate;
    }

    hasQuantityError(item: Item, typeOfQuantity: 'current' | 'cart') {
        return this.giacenzaControl.hasQuantityError(item.cartItem, typeOfQuantity, item.quantityControl.value, item.quantity);
    }

    checkData() {
        if (!this.account.getUser()) {
            this.router.navigate(['/auth/login'], { queryParams: { from: 'cart' } });
            return;
        }

        for (let item of this.items) {
            if (this.hasQuantityError(item, 'current')) {
                Swal.fire({
                    icon: 'warning',
                    iconColor: '#ffd333',
                    html: `<div style="text-center">Alcuni articoli non sono disponibili o la quantità richiesta non è disponibile.<br>Si prega di controllare e correggere.</div>`,
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                    focusConfirm: false,
                    showCloseButton: true,
                    allowEnterKey: true,
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: 'btn btn-primary btn-margin',
                    },
                });
                return;
            }
        }

        if (this.curShipLimitErrorsArr.length) {
            Swal.fire({
                icon: 'warning',
                iconColor: '#ffd333',
                html: `<div style="text-center">Alcuni articoli non soddisfano le condizioni della spedizione<br>Controlla e modifica il carrello o cambia la spedizione</div>`,
                showConfirmButton: true,
                confirmButtonText: 'OK',
                focusConfirm: false,
                showCloseButton: true,
                allowEnterKey: true,
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-primary btn-margin',
                },
            });
            return;
        }

        if (!this.destinazioneScelta) {
            Swal.fire({
                title: 'Destinazione non scelta',
                text: 'Aggiungi destinazione per procedere',
                confirmButtonText: 'Aggiungi',
                icon: 'error'
            }).then(result => {
                if (result.value) {
                    this.router.navigateByUrl('/account/addresses/new?from=cart');
                }
            });
            return;
        }

        if (!this.modalitaDiSpedizione)
            return;

        if (!this.controlModalitaDiSpedizione.value) {
            Swal.fire('Modalità di spedizione non scelta', 'Scegli modalità di spedizione per procedere', 'error');
            return;
        }

        if (this.impostazioni_consegna['attivo'] && this.fasciaAttiva()) {
            if (this.impostazioni_consegna['flg_fascia']) {
                if (this.impostazioni_consegna['flg_obb_data']) {
                    if (!this.fasciaGiorno.value) {
                        Swal.fire('Giorno di consegna non scelta', 'Scegli giorno di consegna per procedere', 'error');
                        return;
                    }
                    else {
                        if (this.impostazioni_consegna['flg_obb_fascia']) {
                            if (!this.fasciaOra.value) {
                                Swal.fire('Fascia oraria di consegna non scelta', 'Scegli fascia oraria di consegna per procedere', 'error');
                                return;
                            }
                        }
                    }

                }

            }
        }
        else {
            this.cart.setDeliveryDate(null);
            this.cart.setDeliveryTime(null);
        }

        if (this.impostazioniRitiroAttivo()) {
            if (!this.ritiroGiorno.value) {
                if (!this.orariDisponibili.length) {
                    Swal.fire('Non ci sono giorni disponibili per il ritiro', `Riprova piu tardi`, 'error');
                }
                else {
                    Swal.fire('Giorno di ritiro non scelto', 'Scegli giorno di ritiro per procedere', 'error');
                }
                return;
            }
            else {
                if (!this.ritiroRange.value) {
                    Swal.fire('Orario di ritiro non scelto', 'Scegli orario di ritiro per procedere', 'error');
                    return;
                }
                else {
                    let giorno = this.ritiroGiorno.value;
                    let ora_range = this.ritiroRange.value;

                    let day = new Date(giorno);
                    day.setHours(0, 0, 0, 0);
                    day.setMinutes(ora_range[0]);

                    this.cart.setRitiroTime(day.toISOString());
                }
            }
        }
        else {
            this.cart.setRitiroTime(null);
        }

        this.router.navigate(['/shop/cart/checkout']);
    }

    getBoxContentDescription(item: Item) {
        let box_levels = item.cartItem.box_levels;
        let errors = this.giacenzaControl.getBoxErrors(item.cartItem, 'current', item.quantityControl.value, item.quantity);
        let items = [];
        for (let level of box_levels) {
            for (let item of level.items) {
                items.push({
                    desc: item.qta_selezionata + ' × ' + (item.articolo_componente ? item.articolo_componente.descart : item.codice_articolo_componente),
                    haveError: errors[item.articolo_componente.codart]
                });
            }
        }
        return items;
    }

    updateSpedizioniNonDisponibili(all_spedizioni) {
        this.spedizioniNonDisponibili = [];

        for (let i = 0; i < 3; i++) {
            let shippingExist = this.modalitaDiSpedizione.find(spedizione => spedizione.tipo_spedizione == i);
            if (shippingExist)
                continue;

            let spedizioni = all_spedizioni.filter(spedizione => spedizione.tipo_spedizione == i);
            if (!spedizioni.length)
                continue;

            spedizioni = JSON.parse(JSON.stringify(spedizioni));

            spedizioni.forEach(spedizione => {
                this.setReasonsNotAvailable(spedizione);
            });
            
            spedizioni.sort((a, b) => {
                let diff = a.reasons[0] - b.reasons[0];
                if (diff)
                    return diff;
                diff = a.reasons.length - b.reasons.length;
                if (diff)
                    return diff;
                for (let i = 1; i < a.reasons.length; i++) {
                    diff = a.reasons[i] - b.reasons[i];
                    if (diff)
                        return diff;
                }
                return this.shippingCost.getPriceOfShipping(a, this.cart.subtotal) -
                    this.shippingCost.getPriceOfShipping(b, this.cart.subtotal);
            });

            this.spedizioniNonDisponibili.push(spedizioni[0]);
        }

    }

    setReasonsNotAvailable(spedizione) {
        let reasons = [];
        let error;

        let errors : any = this.principioArticoloHaveErrors(spedizione);
        if (errors) {
            reasons.unshift(REASON_NOT_AVAILABLE.PRINCIPIO_ARTICOLO);
            error = errors;
        }

        errors = this.limitHaveErrors(spedizione);
        if (errors) {
            reasons.unshift(REASON_NOT_AVAILABLE.LIMIT);
            error = errors;
        }
    
        errors = this.principioGeoHaveErrors(spedizione);
        if (errors) {
            reasons.unshift(REASON_NOT_AVAILABLE.PRINCIPIO_GEOGRAFICO);
            error = errors;
        }

        errors = this.principioClienteHaveErrors(spedizione);
        if (errors) {
            reasons.unshift(REASON_NOT_AVAILABLE.PRINCIPIO_CLIENTE);
            error = errors;
        }

        if (reasons.length == 0) {
            reasons.unshift(REASON_NOT_AVAILABLE.PRINCIPIO_PESO);
            error = "il carrello non rientra nei limiti di volume e peso attualmente gestibili, contattare l'assistenza clienti";
        }

        spedizione.error_data = error;
        spedizione.reasons = reasons;
    }

    principioArticoloHaveErrors(spedizione) {
        if (!spedizione.condizione_articoli)
            return false;

        let listOfErrors = [];
        for (let item of this.cart.items) {
            let articolo = item.product;
            let includedByCodArt = spedizione.principi_articolo.find(principio => principio.flag_escluso_incluso && principio.codice_articolo == articolo.codart);
            if (includedByCodArt) {
                if (includedByCodArt.limite_max && (includedByCodArt.limite_max < item.quantity)) {
                    listOfErrors.push({
                        articolo: articolo.descart,
                        message: `Limite massimo (${includedByCodArt.limite_max}) superato`
                    });
                }
                if (includedByCodArt.limite_min && (includedByCodArt.limite_min > item.quantity))
                    listOfErrors.push({
                        articolo: articolo.descart,
                        message: `Limite minimo (${includedByCodArt.limite_min}) non raggiunto`
                    });

                continue;
            }

            let excludedByCodArt = spedizione.principi_articolo.find(principio => !principio.flag_escluso_incluso && principio.codice_articolo == articolo.codart);
            if (excludedByCodArt) {
                listOfErrors.push({
                    articolo: articolo.descart,
                    message: `Non disponibile per questa spedizione`
                })
                continue;
            }

            let includedByMarcaOrFamily = spedizione.principi_articolo.find(principio => {
                if (!principio.flag_escluso_incluso)
                    return false;
                if (principio.codice_marca && principio.codice_marca == articolo.marca)
                    return true;
                for (let i = 1; i <= 3; i++) {
                    for (let suffix of ['string', 'int', 'decimal']) {
                        const key = `ext_${suffix}_${i}`;
                        if (principio[key] && principio[key] == articolo[key])
                            return true;
                    }
                }
                if (principio.codice_famiglia && (articolo.famiglia == principio.codice_famiglia)) {
                    if (principio.codice_sottofamiglia) {
                        if (articolo.sottofamiglia == principio.codice_sottofamiglia) {
                            if (principio.codice_gruppo) {
                                if (articolo.gruppo == principio.codice_gruppo) {
                                    if (principio.codice_sottogruppo) {
                                        if (articolo.sottogruppo == principio.codice_sottogruppo)
                                            return true;
                                    } else return true;
                                }
                            } else return true;
                        }
                    } else return true;
                }
                return false;
            });

            if (includedByMarcaOrFamily)
                continue;

            let excludedByMarcaOrFamily = spedizione.principi_articolo.find(principio => {
                if (principio.flag_escluso_incluso)
                    return false;
                if (principio.codice_marca && principio.codice_marca == articolo.marca)
                    return true;
                for (let i = 1; i <= 3; i++) {
                    for (let suffix of ['string', 'int', 'decimal']) {
                        const key = `ext_${suffix}_${i}`;
                        if (principio[key] && principio[key] == articolo[key])
                            return true;
                    }
                }
                if (principio.codice_famiglia && (articolo.famiglia == principio.codice_famiglia)) {
                    if (principio.codice_sottofamiglia) {
                        if (articolo.sottofamiglia == principio.codice_sottofamiglia) {
                            if (principio.codice_gruppo) {
                                if (articolo.gruppo == principio.codice_gruppo) {
                                    if (principio.codice_sottogruppo) {
                                        if (articolo.sottogruppo == principio.codice_sottogruppo)
                                            return true;
                                    } else return true;
                                }
                            } else return true;
                        }
                    } else return true;
                }
                return false;
            });

            if (excludedByMarcaOrFamily)
                listOfErrors.push({
                    articolo: articolo.descart,
                    message: `Non disponibile con la spedizione scelta`
                });
        }

        return listOfErrors ? listOfErrors : false;
    }

    limitHaveErrors(spedizione) {
        if (spedizione.min_ordine && spedizione.min_ordine > this.cart.subtotal)
            return `minimo spesa (${spedizione.min_ordine}€) non raggiunto`;
        if (spedizione.max_ordine && spedizione.max_ordine < this.cart.subtotal)
            return `massimo spesa (${spedizione.max_ordine}€) superato`;
    }

    principioGeoHaveErrors(spedizione) {
        let address = this.destinazioneScelta;
        let matchAddress = function (principio) {
            return principio.cap == address.cap || principio.pr == address.prov || principio.nazione == address.stato
            || (haversine_distance(address, principio) < principio.distanza);
        }

        let excludedByGeo = spedizione.principi_geografici.filter(principio => {
            return !principio.flag_escluso_incluso && matchAddress(principio);
        });

        const err_msg = "il tuo indirizzo non è coperto";
        if (excludedByGeo.length)
            return err_msg;
        
        let includedByGeo = spedizione.principi_geografici.filter(principio => {
            return principio.flag_escluso_incluso && matchAddress(principio);
        });

        if (includedByGeo.length)
            return false;

        return err_msg;
    }

    principioClienteHaveErrors(spedizione) {
        return false;
    }

    curShipLimitErrorsObj = {}
    curShipLimitErrorsArr = [];
    checkLimitsForSelectedShipping(codice_spedizione, all_spedizioni) {
        this.curShipLimitErrorsObj = {};
        this.curShipLimitErrorsArr = [];

        if (!codice_spedizione)
            return;

        let spedizione = all_spedizioni.find(spedizone => spedizone.codice == codice_spedizione);

        if (!spedizione.condizione_articoli)
            return;

        for (let item of this.cart.items) {
            let articolo = item.product;
            let includedByCodArt = spedizione.principi_articolo.find(principio => principio.flag_escluso_incluso && principio.codice_articolo == articolo.codart);
            if (includedByCodArt) {
                if (includedByCodArt.limite_max && (includedByCodArt.limite_max < item.quantity)) {
                    this.curShipLimitErrorsObj[articolo.codart] = `Limite massimo (${includedByCodArt.limite_max}) superato`;
                    this.curShipLimitErrorsArr.push({
                        articolo: articolo.descart,
                        message: this.curShipLimitErrorsObj[articolo.codart]
                    });
                }

                if (includedByCodArt.limite_min && (includedByCodArt.limite_min > item.quantity)) {
                    this.curShipLimitErrorsObj[articolo.codart] = `Limite minimo (${includedByCodArt.limite_min}) non raggiunto`;
                    this.curShipLimitErrorsArr.push({
                        articolo: articolo.descart,
                        message: this.curShipLimitErrorsObj[articolo.codart]
                    });
                }
            }
        }
    }

    getSpedizioneByType(tipo) {
        return this.modalitaDiSpedizione?.find(s => s.tipo_spedizione == tipo);
    }

    getSpedizioneNonDisponibileByType(tipo) {
        return this.spedizioniNonDisponibili?.find(s => s.tipo_spedizione == tipo);
    }

    changeItemContent(item : Item) {
        let modalRef = this.modalService.show(ProductCustomizationComponent, {
            class: 'modal-dialog-centered modal-xl customized-modal-dialog',
            initialState: {
                type: 'edit',
                item: item,
            }
        });
        modalRef.onHide.subscribe(r => {
            item.quantityControl.setValue(item.quantityControl.value);
        });
    }
}

function haversine_distance(p1, p2)
{
    const toRad = (x) => x * Math.PI / 180;
    const R = 6371.071; // km

    const sLat1 = Math.sin(toRad(p1.latitudine));
    const sLat2 = Math.sin(toRad(p2.latitudine));
    const cLat1 = Math.cos(toRad(p1.latitudine));
    const cLat2 = Math.cos(toRad(p2.latitudine));
    const cLng = Math.cos(toRad(p1.longitudine) - toRad(p2.longitudine));

    const cosD = sLat1*sLat2 + cLat1*cLat2*cLng;
    const d = Math.acos(cosD);
    const dist = R * d;

    return dist;
}